export enum CmFieldTypeEnum {
  Text = "Text",
  Textarea = "Textarea",
  Boolean = "Boolean",
  Number = "Number",
  Date = "Date",
  SingleSelect = "SingleSelect",
  MultiSelect = "MultiSelect",
}

export const MAX_CM_TEXT_LENGTH = 1024